module.exports = __webpack_public_path__ + "static/media/1-3.36e01129.webp";